import sdl from '@jds/react-generated-sdl/JDSDropdownMenuGroup';
import type { JDSDropdownMenuGroupProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, DropdownMenuGroupProps } from '../logic';

const Component = (props: DropdownMenuGroupProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { hideBottomDivider = false, custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { hideBottomDivider, ...rest },
    'JDSDropdownMenuGroup',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DropdownMenuGroup = withLogic(
  Component
) as React.FC<DropdownMenuGroupProps> & { slotName?: string };

DropdownMenuGroup.displayName = 'DropdownMenuGroup';
DropdownMenuGroup.slotName = 'jds_dropdown_menu_group';

export { DropdownMenuGroup, type JDSDropdownMenuGroupProps };
